import { UnstyledButton } from '@mantine/core';
import { LucideIcon } from 'lucide-react';
import { FC } from 'react';

interface Props {
    icon: LucideIcon;
    label: string;
    onClick: () => void;
}

const NavMenuItem: FC<Props> = ({ icon: Icon, label, onClick }) => {
    return (
        <UnstyledButton className="flex flex-col items-center py-1.5" onClick={onClick}>
            <Icon className="size-5" />
            <p className="text-sm">{label}</p>
        </UnstyledButton>
    );
};

export default NavMenuItem;
